import { TextField } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import * as Yup from "yup";
import AdvancedFilter from "../../../component/AdvancedFilter";
import { addFilter } from "../../../utils/FilterUtils";
import { ID_FILTER_PREVIEW_INTERMEDIARY } from "../constants/IntermediariesFilters";
import { STATE_PREVIEW_ACTIVE_FILTERS } from "../constants/IntermediariesRecoil";

const ReportPreviewFilter = (props: any) => {

    const {t} = useTranslation('finance', {keyPrefix: 'intermediaries'});

    const setFilters = useSetRecoilState(STATE_PREVIEW_ACTIVE_FILTERS);

    const schema = Yup.object().shape({
        intermediary: Yup.string(),
    });

    const defaultValues = {intermediary: ""};

    const renderIntermediary = (field: any) => (
        <TextField
            fullWidth
            value={field.value}
            onChange={field.onChange}
            label={t('filters.intermediary')}
        />
    );

    const mainFields = {
        intermediary: renderIntermediary,
    }
    const submit = (data: any) => {
        props.setUpdating(true);
        addFilter(setFilters, ID_FILTER_PREVIEW_INTERMEDIARY, data.intermediary);
    }

    const reset = () => {
        props.setUpdating(true);
        setFilters([]);
    }

    return (
        <AdvancedFilter schema={schema} mainFields={mainFields}
                        defaultValues={defaultValues}
                        onSubmit={submit}
                        onReset={reset}
        />
    )
}

export default ReportPreviewFilter;